/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { FullScreenDialog } from "components/common/Modal";
import { I18nTrans, useI18n } from "hooks/i18n/i18n";
import React from "react";
import { Link, useHistory } from "react-router-dom";

export const RequiredTicketsNotFoundModal: React.FC<{
  returnLink: string;
  open: boolean;
  purchaseType: "upgrade" | "discount";
}> = ({ returnLink, open, purchaseType }) => {
  const history = useHistory();
  const { t } = useI18n();

  const modalHeaderText =
    purchaseType === "upgrade"
      ? t("event.ticket.requiredTicketsNotFoundModal.upgradeTitle")
      : t("event.ticket.requiredTicketsNotFoundModal.discountTitle");

  return (
    <FullScreenDialog
      maxWidth={"sm"}
      open={open}
      onBackdropClick={() => history.replace(returnLink)}
    >
      <div css={root}>
        <div css={textLayout}>
          <h2 css={h2}>{modalHeaderText}</h2>
          <p css={p}>
            <I18nTrans i18nKey="event.ticket.requiredTicketsNotFoundModal.description">
              対象チケットが未購入か、別のアカウントでログインしている可能性があります。
              <Link to="/account/ticket" css={a}>
                マイチケット
              </Link>
              からチケットの保有状況をご確認ください。
            </I18nTrans>
          </p>
        </div>

        <button
          type="button"
          css={button}
          onClick={() => history.replace(returnLink)}
        >
          {t("event.ticket.requiredTicketsNotFoundModal.back")}
        </button>
      </div>
    </FullScreenDialog>
  );
};

const root = css({
  display: "flex",
  flexDirection: "column",
  gap: "40px",
  padding: "24px",
  /* stylelint-disable-next-line */
  "@media screen and (min-width: 768px)": {
    padding: "60px",
  },
});

const textLayout = css({
  display: "flex",
  flexDirection: "column",
  gap: "24px",
  textAlign: "center",
});

const h2 = css({
  color: "#000",
  fontSize: "20px",
  fontWeight: 700,
  lineHeight: "1.3em",
  wordBreak: "auto-phrase",
  /* stylelint-disable-next-line */
  "@media screen and (min-width: 768px)": {
    fontSize: "24px",
  },
});

const p = css({
  fontSize: "16px",
  lineHeight: "1.5em",
  textAlign: "left",
});

const a = css({
  color: "#00c2ad",
  textDecoration: "underline",
});

const button = css({
  width: "100%",
  padding: "12px 0",
  color: "#fff",
  fontWeight: 700,
  letterSpacing: "1px",
  backgroundColor: "#00c2ad",
  border: "none",
  cursor: "pointer",
});
